import { PrimaryControlsStripExpansionDisplayPushButton } from "@-/dev.improve.haniverse.routes.nav.app._components.primary-controls-strip.expansion.push-button.display";
import { PrimaryControlsStripExpansionMutePushButton } from "@-/dev.improve.haniverse.routes.nav.app._components.primary-controls-strip.expansion.push-button.mute";
import { View } from "@-/com.npmjs.react-native";

export function BrowsePrimaryControlsStripExpansionPushButtons() {
  return (
    <View className="flex-row items-center justify-center gap-2 py-1">
      <PrimaryControlsStripExpansionDisplayPushButton />
      <PrimaryControlsStripExpansionMutePushButton />
    </View>
  );
}
